import React, { useEffect, useRef, useState } from 'react'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { RecordsKeeperAIBreadCrumbs, RecordSync } from '../../core/_constants'
import { useIntl } from 'react-intl'
// import FilterIconFunnel from '../../../../../media/resources/icons/filterIcon.svg'
import threeDots from '../../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import { useThemeMode } from '../../../../../_metronic/partials'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import MetaData from './MetaData'
import ActivityLogs from './ActivityLogs'
import SecurityAndPermissions from './SecurityAndPermissions'
import AccessLogs from './AccessLogs'
// import Integrity from './Integrity'
import LinkedRecords from './LinkedRecords'
import ComplianceAndLegal from './ComplianceAndLegal'
import Notifications from './Notifications'
import Actions from './Actions'
import { ToolTipUI } from '../../../widgets/components/UI/ToolTipUI'
import TagManager from 'react-gtm-module'
import { toast } from 'react-toastify'
import { GTMEvent } from '../../../../hooks/gtmHelpers'
import ShareModal from '../../../widgets/components/ShareModal'
import { Link, useNavigate, useParams } from 'react-router-dom'
import LabelWithTooltip from '../LabelWithTooltip'
import { useAuth } from '../../../auth'
import {
  checkRole,
  createAccess,
  createActivityLog,
  createSourceFileToSync,
  getFileVersionsApi,
  getMetaData,
  getViewAndDownloadFile,
} from '../../core/_requests'
import Skeleton from 'react-loading-skeleton'
import { getFileType } from '../../../../core/_util'
import ViewDocModal from '../../../stakeholders/stakeholders-and-investors/components/individual/view-doc-modal'
import { allowedFileTypes } from '../../../../core/_constants'
import { FileUpload } from '../../../widgets/components/FileUpload'
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { RecordKeeperCreateLinkDrawer } from './RecordKeeperCreateLinkDrawer'
import { MoveToFolderModal } from '../MoveToFolderModal'
import { getLocation } from '../../../onboarding/core/_requests'
import { RequestFileStatusModal } from '../RequestFileStatusModal'
import { RequestAccessModal } from '../RequestAccessModal'
import { RecordShareDrawer } from '../RecordShareDrawer'

const FileDetails = () => {
  const { formatMessage } = useIntl()
  const { companyId, currentUser } = useAuth()
  const { recordId } = useParams()
  const [fileVersionLoading, setFileVersionLoading] = useState<boolean>(false)
  // const [search, setSearch] = useState('') //eslint-disable-line
  // const [filter, setFilter] = useState(false) //eslint-disable-line
  const [metadataLoading, setMetaDataLoading] = useState<boolean>(false)
  const [isActive, setIsActive] = useState(false)
  const [metaData, setMetaData] = useState<any>()
  const { mode } = useThemeMode()
  const [isShareModal, setIsShareModal] = useState(false)
  const link = 'b012eca0-92cb-431c-bb59-3286dfe1a137'
  const [textToCopy, setTextToCopy] = useState<string>(link || '') //eslint-disable-line
  const [modalContainer, setModalContainer] = useState<any>()
  const [modalStatus, setModalStatus] = useState(false)
  const [sidebar, setSidebar] = useState(1)
  const [showKebabMenu, setShowKebabMenu] = useState(false)
  const [selectedVersion, setSelectedVersion] = useState('')
  const [viewableData, setViewableData] = useState<
    { downloadUrl: string; fileName: string; extension: string } | {}
  >({})
  const [showAccessModal, setShowAccessModal] = useState<boolean>(false)
  const [showFileStatusModal, setFileStatusModal] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState(false)
  const [fileVersionOptions, setFileVersionOptions] = useState<any[]>([])
  const [createLinkDrawer, setCreateLinkDrawer] = useState(false)
  const navigate = useNavigate()
  const [showMoveModal, setMoveShowModal] = useState(false)
  const [isFileSyncing, setIsFileSyncing] = useState(false)
  const [action, setAction] = useState('')
  const [roleCheckValidatorLoader, setRoleCheckValidatorLoader] = useState<boolean>(false)
  const [uploadUpdatedButtonIsClicked, setUploadUpdatedButtonIsClicked] = useState(false)
  const [isOpenShareDrawer, setIsOpenShareDrawer] = useState(false)
  const sidebarOptions = [
    { title: formatMessage({ id: 'Metadata' }) },
    { title: formatMessage({ id: 'Activity Logs' }) },
    { title: formatMessage({ id: 'Security & Permissions' }) },
    { title: formatMessage({ id: 'Access Log' }) },
    // {title: formatMessage({id: 'Integrity'})},
    { title: formatMessage({ id: 'Linked records' }) },
    { title: formatMessage({ id: 'Compliance & Legal' }) },
    { title: formatMessage({ id: 'Notifications' }) },
    { title: formatMessage({ id: 'Others' }) },
  ]

  const getAllMetaData = async (recordId: string) => {
    if (!companyId) return
    try {
      setMetaDataLoading(true)
      const {
        data: { data, success, errors },
      } = await getMetaData(companyId, recordId, selectedVersion)
      if (success) {
        setMetaData(data)
        setSelectedVersion(data.metadata.fileVersionId)
      } else {
        toast.error(errors[0])
      }
    } catch (err) {
    } finally {
      setMetaDataLoading(false)
    }
  }

  const getFileVersions = async (recordId: string) => {
    if (!companyId) return
    try {
      setFileVersionLoading(true)
      const {
        data: { data, success, errors },
      } = await getFileVersionsApi(recordId, companyId)
      if (success) {
        setFileVersionOptions(
          data.recordVersionFiles.map((item: any) => ({
            id: item.fileVersionId,
            label: item.version,
            value: item.fileVersionId,
          }))
        )
      } else {
        toast.error(errors[0])
      }
    } catch (err) {
    } finally {
      setFileVersionLoading(false)
    }
  }

  useEffect(() => {
    if (recordId) {
      getAllMetaData(recordId)
    }
  }, [selectedVersion, recordId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (recordId) {
      getFileVersions(recordId)
    }
  }, [recordId]) // eslint-disable-line react-hooks/exhaustive-deps
  const checkRoleValidate = async (action: string) => {
    setRoleCheckValidatorLoader(true)
    if (!companyId || !recordId) return
    try {
      const {
        data: { success, data },
      } = await checkRole(recordId, companyId, action)
      if (success) {
        console.log(data.unAuthorized)
        setUploadUpdatedButtonIsClicked(false)

        if (data.editAccess && data.viewAccess && !data.isPending) {
          if (action === 'UPLOAD') setModalStatus(true)
          if (action === 'MOVE') setMoveShowModal(true)
        }
        if (data.isPending) setFileStatusModal(true)
        if (data.unAuthorized) setShowAccessModal(true)
        if (data.isRejected) toast.error('Your request has been rejected')
      }
    } catch (err) {
    } finally {
      setRoleCheckValidatorLoader(false)
    }
  }
  // const handleFilter = () => {
  //   setFilter(true)
  // }
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowKebabMenu(false)
    }
  }
  useEffect(() => {
    // Attach the event listener
    document.addEventListener('mousedown', handleClickOutside)

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  function handleCopy(event: React.MouseEvent<HTMLImageElement>) {
    // Ensure linkToCopy is always a string
    const linkToCopy = textToCopy || '' // Fallback to empty string if undefined

    navigator.clipboard
      .writeText(linkToCopy)
      .then(() => {
        toast.success('Text copied to clipboard')
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ShareSocialMedia,
            action: 'normal',
            metadata: {
              link: linkToCopy, // Use the copied link
              company_id: 'static_company_id', // Static data
              user_id: 'static_user_id', // Static data
              email: 'static_email@example.com', // Static data
            },
          },
        })
      })
      .catch((err) => {
        console.error('Failed to copy: ', err)
        toast.error('Failed to copy link')
      })

    event.preventDefault()
  }

  const formatDate = (dateString: string) => {
    if (!dateString) return ''
    return new Date(dateString).toLocaleString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
  }
  const getDeviceType = () => {
    const ua = navigator.userAgent

    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera Mobi|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
        ua
      )
    ) {
      return 'MOBILE'
    }
    return 'WEB'
  }

  const getOS = () => {
    const ua = navigator.userAgent
    if (/iPhone|iPad|iPod|Macintosh/.test(ua)) return 'APPLE'
    if (/Win/.test(ua)) return 'WINDOWS'
    if (/android/i.test(ua)) return 'ANDROID'
    return 'Unknown'
  }
  const createActivity = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name
    const ipAddress = locationApiData?.data?.ip
    try {
      if (deviceTypeView && os && city && recordId && companyId) {
        const {
          data: { success, errors },
        } = await createActivityLog(
          companyId,
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'VIEWED'
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  const createAccessLog = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name
    const ipAddress = locationApiData?.data?.ip

    try {
      if (deviceTypeView && os && city && recordId && companyId && currentUser?.userId) {
        const {
          data: { success, errors },
        } = await createAccess(
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'CREATE',
          companyId,
          currentUser?.userId
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  const handleViewAndDownloadFile = async (isDownload: boolean) => {
    if (!companyId) return
    if (!isDownload) setIsActive(true)
    setIsLoading(true)
    try {
      const {
        data: { data, success },
      } = await getViewAndDownloadFile(metaData?.metadata?.fileVersionId, companyId, isDownload)
      if (success) {
        if (isDownload) {
          const link = document.createElement('a')
          link.href = data.downloadUrl
          link.setAttribute('download', metaData?.metadata?.fileName || 'downloaded-file') // Ensure a valid filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          toast.success(`${metaData?.metadata?.fileName} downloaded successfully`)
        } else {
          setViewableData(data)
          createActivity(metaData?.metadata?.recordId)
          createAccessLog(metaData?.metadata?.recordId)
        }
      }
    } catch (error) {
      toast.error('Failed to download document')
    } finally {
      setIsLoading(false)
    }
  }

  const handleFileSync = async () => {
    if (!companyId) return
    if (!recordId) return
    setIsFileSyncing(true)
    try {
      const {
        data: { success, errors },
      } = await createSourceFileToSync(
        metaData?.metadata?.fileVersionId,
        metaData?.metadata?.recordKeeperSource?.cloudType,
        companyId
      )
      if (success) {
        toast.success('File new version synced successfully')
        await getAllMetaData(recordId)
      } else {
        toast.error(errors[0])
      }
    } catch (error) {
      toast.error('Failed to sync file')
    } finally {
      setIsFileSyncing(false)
    }
  }

  return (
    <>
      <div>
        <PageTitle
          breadcrumbs={RecordsKeeperAIBreadCrumbs}
          description={formatMessage({ id: 'Records & Files' })}
        >
          {formatMessage({ id: 'RecordsKeeper AI' })}
        </PageTitle>
        <div className='px-6'>
          <div className='d-md-flex justify-content-between align-items-center'>
            <div className='d-flex align-items-center mt-1 gap-3'>
              <i className='fa-solid fa-arrow-left text-primary'></i>
              <Link
                className='m-0 text-primary'
                to={`/rk/records-and-files/${encodeURIComponent(
                  metaData?.metadata?.structureClassificationLevelOne.name
                )}/${encodeURIComponent(
                  metaData?.metadata?.structureClassificationLevelTwo.name
                )}/${encodeURIComponent(metaData?.metadata?.structureClassificationLevelThree)}/${metaData?.metadata?.structureClassificationLevelThreeQuartely
                  ? `${encodeURIComponent(
                    metaData?.metadata?.structureClassificationLevelThreeQuartely
                  )}/`
                  : ''
                  }${metaData?.metadata?.structureClassificationLevelThreeMonthly
                    ? `${encodeURIComponent(
                      metaData?.metadata?.structureClassificationLevelThreeMonthly
                    )}/`
                    : ''
                  }${encodeURIComponent(metaData?.metadata?.structureClassificationLevelFour.name)}`}
              >
                {formatMessage({ id: 'Go Back' })}
              </Link>
            </div>
            {/* <div className='d-flex justify-content-md-end justify-content-between gap-2 mt-2 mt-mb-auto'>
            <div className='h-100 border bg-white d-flex align-items-center rounded'>
              <button
                className='text-clr88 btn btn-sm btn-flex fw-semibold font-size-13 py-4 py-md-3'
                title='Sort and Filter'
                type='button'
                onClick={handleFilter}
              >
                <img src={FilterIconFunnel} alt='' />
                <span className='d-none d-md-block ms-2'>{formatMessage({id: 'Filter'})}</span>
              </button>
            </div>
            <form className=' align-items-center w-100 w-md-auto d-flex'>
              <span className='svg-icon svg-icon-3 position-absolute ms-3'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  className='mh-50px'
                >
                  <rect
                    opacity='0.5'
                    x='17.0365'
                    y='15.1223'
                    width='8.15546'
                    height='2'
                    rx='1'
                    transform='rotate(45 17.0365 15.1223)'
                    fill='currentColor'
                  ></rect>
                  <path
                    d='M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z'
                    fill='currentColor'
                  ></path>
                </svg>
              </span>
              <input
                type='text'
                className='bg-body form-control form-control-flush ps-10 height-36px rounded font-weight-400 text-clrA1'
                name='search'
                placeholder='Search Documents'
                data-kt-search-element='input'
                onChange={(e: any) => {
                  const timeout = setTimeout(() => {
                    setSearch(e.target.value)
                  }, 500)
                  return () => clearTimeout(timeout)
                }}
              />
            </form>
          </div> */}
          </div>
          <div className='mt-4 mb-8'>
            <div className='bg-white w-100 p-4 rounded-top'>
              <div
                className='d-md-flex justify-content-between w-100 align-items-top mb-4 px-4'
                style={{ borderBottom: '1px dotted #DBDFE9' }}
              >
                <div className='d-flex gap-md-4 gap-2'>
                  {metadataLoading ? (
                    <Skeleton
                      width={48}
                      height={48}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    <img
                      src={getFileType(metaData?.metadata?.fileName)}
                      alt='file-type'
                      width={48}
                      height={48}
                    />
                  )}
                  <div className='d-flex flex-column align-items-start gap-2'>
                    <div className='d-flex align-items-center'>
                      {metadataLoading ? (
                        <Skeleton
                          width={100}
                          height={25}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <span ref={(node) => setModalContainer(node)}>
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='tooltip'>
                                <p className='m-0'>
                                  {metaData?.fileData?.documentName.split('.')[0]}
                                </p>
                              </Tooltip>
                            }
                            container={modalContainer}
                          >
                            <h1 className='font-size-16 m-0'>
                              {metaData?.fileData?.documentName.split('.')[0].length > 30
                                ? `${metaData?.fileData?.documentName
                                  .split('.')[0]
                                  .substring(0, 30)}...`
                                : metaData?.fileData?.documentName.split('.')[0]}
                            </h1>
                          </OverlayTrigger>
                        </span>
                      )}
                      {metadataLoading || fileVersionLoading ? (
                        <Skeleton
                          width={100}
                          height={25}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          className='rounded-pill ms-3'
                        />
                      ) : (
                        <Dropdown className='version-dropdown'>
                          <Dropdown.Toggle
                            variant='transparent'
                            id='dropdown-basic'
                            className='p-0'
                          >
                            <span className='badge text-muted font-size-10 p-3 border rounded-pill ms-md-2 my-2 my-md-auto'>
                              v{' '}
                              {
                                fileVersionOptions.find((item: any) => item.id === selectedVersion)
                                  ?.label
                              }
                              <i className='fa-solid fa-chevron-down font-size-10 ms-2'></i>
                            </span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            onClick={(e) => {
                              const selectedText = (e.target as HTMLElement).textContent

                              setSelectedVersion(
                                fileVersionOptions.find((item: any) => item.label === selectedText)
                                  ?.id
                              )
                            }}
                          >
                            {fileVersionLoading ? (
                              <>
                                <Dropdown.Item>
                                  <Skeleton
                                    width={100}
                                    height={25}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </Dropdown.Item>
                                <Dropdown.Item>
                                  <Skeleton
                                    width={100}
                                    height={25}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </Dropdown.Item>
                                <Dropdown.Item>
                                  <Skeleton
                                    width={100}
                                    height={25}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </Dropdown.Item>
                                <Dropdown.Item>
                                  <Skeleton
                                    width={100}
                                    height={25}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </Dropdown.Item>
                              </>
                            ) : (
                              <>
                                {fileVersionOptions
                                  .sort((a, b) => a.label - b.label)
                                  .map((item: any) => (
                                    <Dropdown.Item
                                      key={item.id}
                                      defaultValue={item.id}
                                      onClick={() => { }}
                                    >
                                      {item.label}
                                    </Dropdown.Item>
                                  ))}
                              </>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                    <div className='d-flex align-items-center gap-2 mb-2'>
                      {metaData?.metadata?.isVerified && (
                        <div className='p-2 py-1 rounded-pill' style={{ background: '#4776E624' }}>
                          <p className='m-0 text-primary font-size-12'>
                            <i className='fa-solid fa-cube text-primary font-size-13 me-2'></i>
                            {formatMessage({ id: 'Verified' })}
                          </p>
                        </div>
                      )}

                      {!metadataLoading && (
                        <p
                          className='m-0 text-primary font-size-13 cursor-pointer'
                          aria-disabled={metadataLoading}
                          onClick={() => {
                            navigate(
                              `/rk/records-and-files/${encodeURIComponent(
                                metaData?.metadata?.structureClassificationLevelOne.name
                              )}/${encodeURIComponent(
                                metaData?.metadata?.structureClassificationLevelTwo.name
                              )}/${encodeURIComponent(
                                metaData?.metadata?.structureClassificationLevelThree
                              )}/${metaData?.metadata?.structureClassificationLevelThreeQuartely
                                ? `${encodeURIComponent(
                                  metaData?.metadata?.structureClassificationLevelThreeQuartely
                                )}/`
                                : ''
                              }${metaData?.metadata?.structureClassificationLevelThreeMonthly
                                ? `${encodeURIComponent(
                                  metaData?.metadata?.structureClassificationLevelThreeMonthly
                                )}/`
                                : ''
                              }${encodeURIComponent(
                                metaData?.metadata?.structureClassificationLevelFour.name
                              )}`
                            )
                          }}
                        >
                          {formatMessage({ id: 'Show in Explorer' })}
                          <i className='fa-solid fa-arrow-up-right-from-square text-primary ms-1 font-size-13 cursor-pointer'></i>
                        </p>
                      )}
                    </div>
                    <ShareModal isActive={isShareModal} setIsActive={setIsShareModal} />
                    <div className='d-flex flex-column gap-2 mb-2'>
                      <p className='m-0 text-muted font-size-13'>
                        {formatMessage({ id: 'Document identifier' })}
                        <span>
                          <ToolTipUI tooltipText='It is a unique alphanumeric code that permanently identifies this specific file within the system, ensuring traceability and preventing duplication.' />
                        </span>
                      </p>
                      {metadataLoading ? (
                        <Skeleton
                          width={100}
                          height={25}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='m-0'>
                          {metaData?.fileData?.recordId}
                          <span>
                            <img
                              src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-copy.svg')}
                              alt='copy icon'
                              className='ms-2 cursor-pointer'
                              onClick={handleCopy}
                            />
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className='d-flex gap-2'>
                  <button
                    className='btn border border-primary justify-content-center text-primary font-weight-400 font-size-13 height-36 d-flex align-items-center w-md-auto w-100'
                    style={mode === 'dark' ? { background: 'transparent' } : { background: '#F0F4FF' }}
                    onClick={() => {
                      setAction('UPLOAD')
                      setUploadUpdatedButtonIsClicked(true)
                      checkRoleValidate('UPLOAD')
                    }}
                    disabled={metadataLoading || roleCheckValidatorLoader}
                  >
                    {roleCheckValidatorLoader && uploadUpdatedButtonIsClicked ? (
                      <span className='indicator-label font-size-13 p-0'>
                        {formatMessage({ id: 'Please wait...' })}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    ) : (
                      formatMessage({ id: 'Upload Updated File' })
                    )}
                  </button>
                  {recordId && (
                    <FileUpload
                      fileSize={parseInt(process.env.REACT_APP_RK_MAX_ZIP_FILE_SIZE as string)}
                      maxFileNumber={1}
                      allowType={allowedFileTypes}
                      metaData={{ module: 'document', isProtected: false }}
                      modalStatus={modalStatus}
                      handleClose={() => {
                        setModalStatus(false)
                      }}
                      handleSuccess={(id: number, name: string) => {
                        toast.success(`${name.split('/').pop()} uploaded successfully!`)
                        getAllMetaData(recordId)
                        getFileVersions(recordId)
                      }}
                      resourceType='all'
                      assemblyOption='rk-doc-upload'
                      isNewVersionFile={true}
                      recordId={recordId}
                      isSingleFile={true}
                    />
                  )}

                  <div
                    role='button'
                    className={`p-3 cursor-pointer bg-light rounded-2 d-flex justify-content-center align-items-top height-36 ${metadataLoading ? 'disabled' : ''
                      }`}
                    onClick={() => {
                      if (!metadataLoading) {
                        handleViewAndDownloadFile(false)
                      }
                    }}
                    aria-disabled={metadataLoading}
                  >
                    <img
                      src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-view.svg')}
                      alt='view'
                      width={20}
                      height={20}
                    />
                  </div>
                  <div
                    role='button'
                    className={`p-3 cursor-pointer bg-light rounded-2 d-flex justify-content-center align-items-top height-36 ${metadataLoading ? 'disabled' : ''
                      }`}
                    onClick={() => {
                      if (!metadataLoading) {
                        handleViewAndDownloadFile(true)
                      }
                    }}
                    aria-disabled={metadataLoading}
                  >
                    <img
                      src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-download.svg')}
                      alt='download'
                      width={20}
                      height={20}
                    />
                  </div>

                  {!(
                    metaData?.metadata?.recordKeeperSource?.cloudType === RecordSync.LOCAL ||
                    metaData?.metadata?.recordKeeperSource?.cloudType === RecordSync.ZIP_FILE
                  ) && (
                      <div
                        role='button'
                        className='p-3 cursor-pointer bg-light rounded-2 d-flex justify-content-center align-items-top height-36'
                        onClick={handleFileSync}
                        aria-disabled={isFileSyncing || metadataLoading}
                      >
                        <img
                          src={toAbsoluteUrl(
                            `/media/icons/RecordsKeeperAI/${isFileSyncing ? 'ic-file-sync.gif' : 'ic-file-sync.svg'
                            }`
                          )}
                          alt='sync'
                          width={18}
                          height={18}
                        />
                      </div>
                    )}

                  <div className='position-relative align-self-top'>
                    <div
                      className='p-3 cursor-pointer bg-light rounded-2 d-flex justify-content-center align-items-center'
                      onClick={() => {
                        setShowKebabMenu(!showKebabMenu)
                      }}
                      aria-disabled={metadataLoading}
                    >
                      <img src={threeDots} alt='' width={16} height={16} />
                    </div>
                    {showKebabMenu && (
                      <div
                        className='card shadow rounded top-4 cursor-pointer z-index-1 position-absolute w-150px'
                        style={{ top: '40px', right: 0 }}
                        ref={dropdownRef}
                      >
                        <div className='border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100'>
                          <button
                            type='button'
                            className='m-0 border-0 bg-transparent text-dark font-size-13 bg-hover-muted'
                            disabled={metadataLoading || roleCheckValidatorLoader}
                            onClick={() => {
                              setAction('MOVE')
                              checkRoleValidate('MOVE')
                            }}
                          >
                            {roleCheckValidatorLoader ? (
                              <span className='indicator-label font-size-13 p-0'>
                                {formatMessage({ id: 'Please wait...' })}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                            ) : (
                              formatMessage({ id: 'Move' })
                            )}
                          </button>
                        </div>
                        <div className=' border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100'>
                          <button
                            type='button'
                            className='m-0 border-0 bg-transparent text-dark font-size-13 bg-hover-muted'
                            disabled={metadataLoading || roleCheckValidatorLoader}
                            onClick={() => {
                              setCreateLinkDrawer(true)
                            }}
                          >
                            {formatMessage({ id: 'Create Link' })}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='d-flex flex-md-row flex-column gap-4 px-4 '>
                <LabelWithTooltip
                  className={'w-md-25 w-100'}
                  label='Owner'
                  value={`${metaData?.fileData?.createdUser?.firstName || ''} ${metaData?.fileData?.createdUser?.lastName || ''
                    }`.trim()}
                  toolTipText='The person who uploaded or created the document and has primary responsibility for its management and updates within the system.'
                  isLoading={metadataLoading}
                />
                <LabelWithTooltip
                  className={'w-md-25 w-100'}
                  label='Copyright info.'
                  value={metaData?.fileData?.createdUser?.email}
                  toolTipText='Email or information about the copyright holder of this document, important for intellectual property tracking and permissions management.'
                />
                <LabelWithTooltip
                  className={'w-md-25 w-100'}
                  label='Date of Creation'
                  value={formatDate(metaData?.fileData?.createdAt)}
                  toolTipText='The timestamp when this document was first uploaded or created in the system, establishing its provenance timeline.'
                />
                <LabelWithTooltip
                  className={'w-md-25 w-100'}
                  label='Last Modification'
                  value={formatDate(metaData?.fileData?.updatedAt)}
                  toolTipText='The timestamp of the most recent change made to this document, helping track version history and recent updates.'
                />
              </div>
            </div>

            <div
              className='mb-4 sidebar-investor-db col-md-1 d-flex bg-white px-4'
              style={{ width: '100%' }}
            >
              <div
                className=' d-flex'
                style={{
                  display: 'flex',
                  overflowX: 'scroll',
                  whiteSpace: 'nowrap',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                {sidebarOptions
                  .slice(
                    0,
                    currentUser?.userId === metaData?.fileData?.createdBy
                      ? sidebarOptions.length
                      : sidebarOptions.length - 3
                  )
                  .map((sideTabs: any, index: number) => (
                    <>
                      <ul
                        className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent text-muted  flex-nowrap mobile-tab-both my-md-0 mb-0'
                        style={{ display: 'flex', flexWrap: 'nowrap' }}
                      >
                        <li
                          key={index}
                          className={
                            `nav-link text-active-primary cursor-pointer py-3 ps-3 d-flex align-items-center` +
                            (sidebar === index + 1
                              ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                              : '')
                          }
                          onClick={() => setSidebar(index + 1)}
                        >
                          {sideTabs.title}
                        </li>
                      </ul>
                    </>
                  ))}
              </div>
            </div>
            <div
              className={`d-flex mb-4 rounded-2 w-100 `}
              style={{ background: mode === 'dark' ? '#323248' : '#f5f8fa' }}
            >
              {sidebar === 1 ? (
                <div className='w-100'>
                  <MetaData
                    metaData={metaData?.metadata}
                    fileData={metaData?.fileData}
                    metadataLoading={metadataLoading}
                    getAllMetaData={getAllMetaData}
                    documentName={metaData?.fileData?.documentName.split('.')[0]}
                  />
                </div>
              ) : sidebar === 2 ? (
                <div className='w-100'>
                  <ActivityLogs />
                </div>
              ) : sidebar === 3 ? (
                <div className='w-100'>
                  <SecurityAndPermissions metaData={metaData?.fileData} />
                </div>
              ) : sidebar === 4 ? (
                <div className='w-100'>
                  <AccessLogs />
                </div>
              ) : sidebar === 5 ? (
                <div className='w-100'>
                  <LinkedRecords />
                </div>
              ) : sidebar === 6 ? (
                <div className='w-100'>
                  <ComplianceAndLegal />
                </div>
              ) : sidebar === 7 ? (
                <div className='w-100'>
                  <Notifications />
                </div>
              ) : (
                <div className='w-100'>
                  <Actions recordId={recordId} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ViewDocModal
        isActive={isActive}
        setIsActive={setIsActive}
        fileName={metaData?.metadata?.fileName}
        isRecordKeeper={true}
        isLoading={isLoading}
        viewableData={viewableData}
      />
      <RecordKeeperCreateLinkDrawer
        recordId={recordId}
        createLinkDrawer={isOpenShareDrawer}
        setCreateLinkDrawer={setIsOpenShareDrawer}
        setCreateRecordDrawer={setCreateLinkDrawer}
      />
      <RecordShareDrawer
        recordId={recordId}
        createRecordDrawer={createLinkDrawer}
        setCreateRecordDrawer={setCreateLinkDrawer}
        setIsOpenShareDrawer={setIsOpenShareDrawer}
      />
      <MoveToFolderModal
        showMoveModal={showMoveModal}
        setMoveShowModal={setMoveShowModal}
        recordId={recordId}
      />
      <RequestAccessModal
        showAccessModal={showAccessModal}
        setShowAccessModal={setShowAccessModal}
        headingMessage="You don't have access to perform this action"
        description={`Your request will be sent to ${metaData?.fileData?.createdUser?.email}.You cannot submit another request for 48 hours after submission`}
        recordId={recordId}
        action={action}
      />
      <RequestFileStatusModal
        showFileStatusModal={showFileStatusModal}
        setFileStatusModal={setFileStatusModal}
        headingMessage='Rquest is already in process'
        description='Your request is in the queue.Please kindly wait until you recieve a response'
      />
    </>
  )
}

export default FileDetails
